module.exports = __webpack_public_path__ + "img/8b3039ba695c36827c9f5cd68f0bbf11.png";